
import { FeaturesService } from "@app/services/Features.service";
import { Inject, Injectable, OnDestroy, OnInit } from "@angular/core";
import { CommonService } from "@app/services/CommonService";
import { WindowToken } from "@app/util/window.token";
import { NavigationStart, Router } from "@angular/router";
import { Subscription } from "rxjs";

@Injectable({ providedIn: "root" })
export class HeaderService implements OnInit, OnDestroy {
    private headerCallback: any;
    private timer: any;
    private timerAttemptsCount: number = 0;
    displayRightContent: boolean = false;
    routerEventSubscription: Subscription;

    constructor(@Inject(FeaturesService) private featuresService: FeaturesService,
                @Inject(CommonService) private commonService: CommonService,
                @Inject(Router) private router: Router,
                @Inject(WindowToken) private $window: Window) {

        if (this.featuresService.isEnabled("REGISTERED_USERS")) {
            //always default to displaying the right content,making each page that wants to hide it make the call
            this.setDisplayRightContent(true);
        }
    }

    ngOnInit() {
        this.routerEventSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.updateHeaderContent(null);
                if (this.featuresService.isEnabled("REGISTERED_USERS") && this.commonService.isRegistered()) {
                    //always default to displaying the right content,making each page that wants to hide it make the call
                    this.setDisplayRightContent(true);
                }
            }
        } )
    }

    setup(headerCallback) {
        // store callback
        this.headerCallback = headerCallback;
    }

    getDisplayRightContent() {
        return this.displayRightContent;
    }

    setDisplayRightContent(displayRightContent: boolean) {
        if (displayRightContent === false) {
            this.displayRightContent = false;

        } else if (this.featuresService.isEnabled("REGISTERED_USERS")) {
            this.displayRightContent = true;

        } else if (displayRightContent) {
            console.error(new Error(`Attempted to show display right content with registered users disabled!`).stack)
        }
    }

    updateHeaderContent = ($removedHeaderBar: any) => {
        if($removedHeaderBar) {
            // reset counter
            this.timerAttemptsCount = 0;
            this.triggerCallback($removedHeaderBar);
        }
    }

    triggerCallback = ($removedHeaderBar: any) => {
        if (this.timer) {
            clearTimeout(this.timer);
        }

        // if callback is setup
        if (this.headerCallback) {
            this.timerAttemptsCount = 0;
            this.headerCallback($removedHeaderBar);
        }
        else {
            // after 60 attempts, don't try anymore
            if (this.timerAttemptsCount < 60) {
                // because of timing issue, try again in next cycle
                this.timer = setTimeout(
                    () => {
                        this.timerAttemptsCount += 1;
                        this.triggerCallback($removedHeaderBar);
                    },
                    1000 / 30
                );
            }
        }
    }

    ngOnDestroy() {
        if (this.routerEventSubscription) {
            this.routerEventSubscription.unsubscribe();
        }
    }
}

